/** The one-time question before new pictures: characters in these shots have no fixed clothing yet. */
export type OutfitsAnswer = "fix" | "vary" | null;

const joinNames = (names: string[]) =>
  names.length <= 1 ? names.join("") : `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;

export function askAboutOutfits(names: string[], doc: Document = document): Promise<OutfitsAnswer> {
  return new Promise((resolve) => {
    const dialog = doc.createElement("dialog");
    dialog.className = "confirm-dialog outfits-question";
    dialog.setAttribute("aria-labelledby", "outfits-question-title");
    const title = doc.createElement("h2");
    title.id = "outfits-question-title";
    title.textContent = `${joinNames(names)} ${names.length === 1 ? "has" : "have"} no fixed clothing yet.`;
    const text = doc.createElement("p");
    text.textContent = "New pictures can then show different clothes in every scene. Fix it first, or let it change on purpose.";
    const actions = doc.createElement("div");
    actions.className = "actions";
    const finish = (answer: OutfitsAnswer) => {
      if (typeof dialog.close === "function" && dialog.open) dialog.close();
      dialog.remove();
      resolve(answer);
    };
    for (const [label, answer, primary] of [
      ["Cancel", null, false],
      ["Let it change per scene", "vary", false],
      ["Fix the clothing first", "fix", true],
    ] as const) {
      const button = doc.createElement("button");
      button.type = "button";
      button.textContent = label;
      if (primary) button.className = "primary";
      button.addEventListener("click", () => finish(answer));
      actions.append(button);
    }
    dialog.addEventListener("cancel", (event) => {
      event.preventDefault();
      finish(null);
    });
    dialog.append(title, text, actions);
    doc.body.append(dialog);
    if (typeof dialog.showModal === "function") dialog.showModal();
    else dialog.setAttribute("open", "");
  });
}
